export default __webpack_public_path__ + "assets/logo_content.png";